/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const initMobileSlider = (elem) => {
    const mql = window.matchMedia("(max-width: 767px)");
    const settings = {
      autoPlay: 5000,
      selectedAttraction: 0.01,
      friction: 0.15,
      pageDots: false,
      prevNextButtons: false
    }
    let flkty = null;

    console.log({ elem, mql })
    if (mql.matches) {
      flkty = new Flickity(elem, settings)
      flkty.resize()
    }

    mql.addEventListener('change', (e) => {
      console.log({ e, Flickity })
      if (e.matches) {
        flkty = new Flickity(elem, settings);
        flkty.resize()
      } else {
        flkty.destroy();
      }
    })
  }

  const domReady = () => {
    const mobileSliders = document.querySelectorAll('.js-mobile-slider .carousel--mobile');
    for (slider of mobileSliders) {
      initMobileSlider(slider);
    }
  }

  document.addEventListener('DOMContentLoaded', domReady);
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
